export function conditionCodeToName(code?: string | null | number): string {
    switch (code?.toString()) {
        case 'U':
            return 'unknown';
        case 'F':
            return 'further';
        case '1':
            return 'excellent';
        case '2':
            return 'good';
        case '3':
            return 'reasonable';
        case '4':
            return 'moderate';
        case '5':
            return 'poor';
        case '6':
            return 'bad';
        default:
            return 'invalid';
    }
}
